import React, { useContext } from "react";
import styled from "styled-components";
import AddAccount from "./components/add-account";
import TableFilters from "./components/table-filters";
import Table from "./components/accounts-table";
import { AuthContext } from "../../../../auth-context";
import { Alert } from "./components/alert";

const AddAccountWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 32px 16px;
  margin: 0 auto;
  max-width: 1600px;
  @media (max-width: 1200px) {
    flex-direction: column;
  }

  @media (max-width: 900px) {
    padding: 16px 8px;
  }
`;

const AddAccountStyled = styled(AddAccount)`
  flex-shrink: 0;
  @media (max-width: 1200px) {
    margin-bottom: 32px;
    width: 100%;
  }
`;

const TableFilterStyled = styled(TableFilters)`
  margin-left: 32px;
  @media (max-width: 1200px) {
    margin-left: 0px;
    padding-bottom: 116px;
  }
`;

const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const emptySeats = user.monthly_peak_basic - user.accounts.length;

  return (
    <>
      {(user.defaultCard.last4 === '' && user.role_id === 1) && (
        <Alert message="Before you can start adding accounts, you must enter a payment method on the Billing page." />
      )}
      {(user.role_id === 1 && emptySeats > 0 && !user.use_flat_rate) && (
        <Alert
          color="yellow"
          message={`There ${emptySeats > 1 ? 'are' : 'is'} ${emptySeats} empty seat${emptySeats > 1 ? 's' : ''}. The next ${emptySeats > 1 ? `${emptySeats} clients` : `client`} added will not increase your billing this cycle. More information can be found on the Billing page.`}
        />
      )}
      <AddAccountWrapper>
        <AddAccountStyled />
        <TableFilterStyled />
      </AddAccountWrapper>
      <Table />
    </>
  );
};

export default Dashboard;
